import { V3Record } from "data/helpers/V3Record.js";

export const Favorite = V3Record("favorite", {
  createdAt: null,
  updatedAt: null,
  userId: null,
  favoritedObjectId: null,
  favoritedObjectType: null,
  source: null, // web mobile s2d download
});
